import { render, staticRenderFns } from "./ArtistSearchInput.vue?vue&type=template&id=70bfafd2&"
import script from "./ArtistSearchInput.vue?vue&type=script&lang=js&"
export * from "./ArtistSearchInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports